// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function inviteAccept(params: { invite_id: number }) {
  return http<{
    detail: string
  }>({
    url: "/api/v1/invites/{invite_id}/accept/",
    method: "post",
    params,
    pathParamNames: ["invite_id"],
  })
}
